export default "__VITE_ASSET__CHzVf0Wm__"